import { render, staticRenderFns } from "./dashboard-step.vue?vue&type=template&id=4cf1d1a2"
import script from "./dashboard-step.vue?vue&type=script&lang=js"
export * from "./dashboard-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports